<div class="profile-container scrollable-container">
    <div class="profile-menu">
        <div class="content-section" fxLayout="row" fxLayoutAlign="space-between center">
            <div class="title">PROFILE</div>
            <div class="cursor" (click)="onCloseMenu()"><img src="assets/icons/closeicon.png" alt="close"></div>
        </div>
    </div>
    <nb-card class="mb-0">
        <nb-card-header class="nb-profile-header">
            <div class="profile-header">
                <div fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
                    <div class="relative" fxLayout="row" fxLayoutAlign="start center">
                        <img [src]="getProfileImageSrc(user?.profileImage)" class="profilepic" alt="profilepic">
                        <div style="padding: 10px;">
                            <div>
                                <span class="information-type">{{user?.employeeName || '-'}}</span>
                            </div>
                            <div>
                                <span class="ps-id-label">
                                    PS ID: </span>
                                <span class="ps-id-value">
                                    {{user?.employeeId || '-'}}
                                </span>
                            </div>
                        </div>
                    </div>
                     <!-- <img class="cursor rightIcon-img" src="assets/icons/next-white.png"
                        (click)="onCloseMenu();navigateById(user?.employeeId)" alt="img"> -->
                    <span class="cursor rightIcon-img" (click)="navigateById(user?.employeeId)">
                        View More
                    </span>
                    <!-- <img class="cursor rightIcon-img" src="assets/icons/next-white.png"
                         alt="img"> -->
                </div>
            </div>
        </nb-card-header>
        <nb-card-body>
            <nb-accordion multi class="profile-accordion">
                <nb-accordion-item class="profile-list-container" [expanded]="true">
                    <nb-accordion-item-header>
                        Personal Information
                    </nb-accordion-item-header>
                    <nb-accordion-item-body>
                        <div class="content-details">
                            <div class="content-details-data">
                                <span class="details-data-title">Designation </span>
                                <span>:</span>
                                <span class="details-data-value">{{user?.designation || '-'}}</span>
                            </div>
                            <div class="content-details-data">
                                <span class="details-data-title">BU </span>
                                <span>:</span>
                                <span class="details-data-value">{{user?.businessUnit || '-'}}</span>
                            </div>
                            <div class="content-details-data">
                                <span class="details-data-title">DU </span>
                                <span>:</span>
                                <span class="details-data-value">{{user?.divisionUnit || '-'}}</span>
                            </div>
                            <div class="content-details-data">
                                <span class="details-data-title">Date of Joining </span>
                                <span>:</span>
                                <span class="details-data-value">{{(user?.dateOfJoining )  || '-'}}</span>
                            </div>
                        </div>
                    </nb-accordion-item-body>
                </nb-accordion-item>
                <nb-accordion-item class="profile-list-container second">
                    <nb-accordion-item-header>
                        Contact Information
                    </nb-accordion-item-header>
                    <nb-accordion-item-body>
                        <div class="content-details">
                            <div class="content-details-data">
                                <span class="details-data-title">Email</span>
                                <span>:</span>
                                <span class="details-data-value">{{user?.email || '-'}}</span>
                            </div>
                            <div class="content-details-data">
                                <span class="details-data-title">
                                    Contact No
                                </span>
                                <span>:</span>
                                <span class="details-data-value">{{user?.mobileNumber || '-'}}</span>
                            </div>
                        </div>
                    </nb-accordion-item-body>
                </nb-accordion-item>
                <nb-accordion-item class="profile-list-container">
                    <nb-accordion-item-header>
                        Other Information
                    </nb-accordion-item-header>
                    <nb-accordion-item-body>
                        <div class="content-details">
                            <div class="content-details-data">
                                <span class="details-data-title">Asset Details </span>
                                <span>:</span>
                                <span class="details-data-value">{{user?.assets[0]?.assetModel || '-'}}</span>
                            </div>
                            <div class="content-details-data">
                                <span class="details-data-title">Location </span>
                                <span>:</span>
                                <span class="details-data-value">{{user?.primaryLocation[0]?.city || '-'}}</span>
                            </div>
                            <div class="content-details-data">
                                <span class="details-data-title">Building</span>
                                <span>:</span>
                                <span class="details-data-value">{{user?.primaryLocation[0]?.building || '-'}}</span>
                            </div>
                            <div class="content-details-data">
                                <span class="details-data-title">Desk No </span>
                                <span>:</span>
                                <span class="details-data-value">{{user?.primaryLocation[0]?.floor || '-'}}</span>
                            </div>
                            <div class="content-details-data">
                                <span class="details-data-title">Seat No </span>
                                <span>: </span>
                                <span class="details-data-value">{{user?.primaryLocation[0]?.seat || '-'}}</span>
                            </div>
                        </div>
                    </nb-accordion-item-body>
                </nb-accordion-item>
            </nb-accordion>
        </nb-card-body>
        <!-- <nb-card-footer>
            <button nbButton size="medium" class="sign-out-button">Sign Out</button>
        </nb-card-footer> -->
    </nb-card>
</div>